let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("3kAza")).then(() => parcelRequire('bo3y3'));